const subticketsOf = (ticket) => {
  if (typeof ticket === 'undefined' || ticket === null) {
    return [];
  }
  if (!Array.isArray(ticket.subtickets)) {
    return [];
  }
  return ticket.subtickets;
};

const isFixedSubticket = (subticket) => {
  if (typeof subticket.fixed === 'boolean') {
    return subticket.fixed;
  }
  const min = parseInt(subticket.min_quantity, 10);
  const max = parseInt(subticket.max_quantity, 10);
  if (Number.isNaN(min) || Number.isNaN(max)) {
    return false;
  }
  return min === max;
};

const fixedSubticketCount = (subticket) => parseInt(subticket.min_quantity, 10) || 0;

const subticketDiscount = (subticket) => {
  if (typeof subticket === 'undefined' || subticket === null) {
    return null;
  }
  if (typeof subticket.discount === 'undefined' || subticket.discount === null) {
    return null;
  }
  return subticket.discount;
};

const subticketPrice = (subticket) => {
  const discount = subticketDiscount(subticket);
  if (discount !== null) {
    return parseInt(discount.new_price, 10);
  }
  return parseInt(subticket.price, 10) || 0;
};

const hasSubtickets = (ticket) => subticketsOf(ticket).length > 0;

const hasSelectableSubtickets = (ticket) =>
  subticketsOf(ticket).some((subticket) => !isFixedSubticket(subticket));

const fixedSubtickets = (ticket) => subticketsOf(ticket).filter(isFixedSubticket);

const selectableSubtickets = (ticket) =>
  subticketsOf(ticket).filter((subticket) => !isFixedSubticket(subticket));

export {
  isFixedSubticket,
  fixedSubticketCount,
  subticketDiscount,
  subticketPrice,
  hasSubtickets,
  hasSelectableSubtickets,
  fixedSubtickets,
  selectableSubtickets,
};

export default {
  isFixedSubticket,
  fixedSubticketCount,
  subticketDiscount,
  subticketPrice,
  hasSubtickets,
  hasSelectableSubtickets,
  fixedSubtickets,
  selectableSubtickets,
};
